﻿module.exports = {
    bindings: {
        isLarge: '<',
        item: '<'
    },
    controller: sectionNotesButton,
    templateUrl: 'texts/components/section-notes-button.html'
};

sectionNotesButton.$inject = ['annotationsModal'];

function sectionNotesButton(annotationsModal) {

    var vm = {
        showAnnotation: showAnnotation
    };

    function showAnnotation() {
        annotationsModal.show(vm.item.section);
    }


    return vm;

}